<div id="hero">
  <app-search-box
    [currentSearchBoxData]="currentSearchBoxData"
  ></app-search-box>
</div>
<div id="top-text">
  <app-inner-html [html]="data.Description"></app-inner-html>
</div>

@if (data && showSearch) {
  <!-- {{ this.searchCriteria | json }}
  {{ data | json }} -->
  <div id="result" [ngClass]="{ 'map-full-width': mapFullWidth }">
    <div id="property-results">
      <app-search-filter
        [properties]="searchResult.Properties"
        [currentSearchFilter]="data.SearchFilterId"
        [currentRatingFilter]="data.StarRatingFilter"
      ></app-search-filter>
      <div class="result-count">
        {{ 48 | translate }}: {{ searchResult.Count }}
      </div>
      @if (isMobile) {
        <button
          class="show-big-map-btn"
          mat-flat-button
          (click)="changeMapFullWidth()"
        >
          @if (mapFullWidth) {
            <span>Skjul kart</span>
          } @else {
            <span>Vis kart</span>
          }
        </button>
      }
      @if (!mapFullWidth) {
        <app-search-property-list
          [properties]="searchResult.Properties"
          [searchResult]="data"
          [settings]="settings"
        ></app-search-property-list>
        @if (showNumberOfResults < searchResult.Count) {
          <button mat-flat-button color="primary" (click)="loadMoreHotels()">
            {{ 47 | translate }}
          </button>
        }
      }
      @if (data.Sections && data.Sections.length > 0) {
        <div id="sections">
          @for (section of data.Sections; track section) {
            <section
              class="{{
                section.Media == null || section.Media.length == 0 ? 'full' : ''
              }}"
            >
              @if (section.Media && section.Media.length > 0) {
                <div class="img-wrapper">
                  @for (media of section.Media; track media) {
                    @if (media.Url) {
                      <img
                        [src]="media.Url | apiImage: 500 : media : 'fill'"
                        [alt]="data.Name"
                        loading="lazy"
                      />
                    }
                  }
                </div>
              }
              <div class="section-text">
                <app-inner-html [html]="section.Description"></app-inner-html>
              </div>
            </section>
          }
        </div>
      }
    </div>
    @if (
      isBrowser && !loadingGoogleMapScript() && (!isMobile || mapFullWidth)
    ) {
      <div id="search-map">
        <app-search-map
          [location]="searchResult"
          [settings]="settings"
        ></app-search-map>
      </div>
    }
  </div>
}
